import { ForkEffect, takeEvery } from 'redux-saga/effects';
import { Socket } from 'socket.io-client';

import { send } from '../send-request';
import {
  crmCustomerAddressUpdate,
  crmCustomerCouponCreate,
  crmCustomerDetailLoad,
  crmCustomerEmailPreviewLoad,
  crmCustomerEmailResend,
  crmCustomerFakturoidSync,
} from './reducer';

export function* watch(
  socket: Socket,
): Generator<ForkEffect<never>, void, string> {
  yield takeEvery(crmCustomerDetailLoad.type, send, socket);
  yield takeEvery(crmCustomerFakturoidSync.type, send, socket);
  yield takeEvery(crmCustomerAddressUpdate.type, send, socket);
  yield takeEvery(crmCustomerEmailResend.type, send, socket);
  yield takeEvery(crmCustomerEmailPreviewLoad.type, send, socket);
  yield takeEvery(crmCustomerCouponCreate.type, send, socket);
}
